import axios from '../axios'
import { ApiController } from './types'

const base = '/client-questions'

const apiController: ApiController = {
  createClientQuestion: async (request) =>
    await axios.post(base, request).then((response) => response.data),
}

export default apiController
